import { Vue } from 'vue-property-decorator';

export default abstract class AbstractRobot extends Vue {
    /** 返回机器人的启用状态. */
    abstract getActiveState(): Promise<boolean>;
    /** 切换到当前机器人配置. */
    abstract onShow(): Promise<void>;
    /** 切换到其他机器人配置. */
    abstract onHide(): Promise<void>;
}
